module.exports = __webpack_public_path__ + "static/media/3C.fede85e4.svg";